import React from 'react';
import {Paper, Popper} from "@material-ui/core";
import BBExternalLink from "../accents/BBExternalLink";
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import BBCodeCopyContainer from "../controllers/BBCodeCopyContainer";
import BBIconCodeDocument from "../../../assets/bbCustomIcons/BBIconCodeDocument";

const OwnershipRequiredPopper = ({open= false, anchorEl=null, })=>{

    const {entityInView, portfolios} = useSelector(({breachrisk})=> breachrisk);
    const {customers, customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    console.log("OwnerwhipsRequiredPopper is being rendered on this page", )

    const verification_id = myEntity
        && myEntity.domains
        && Object.values(myEntity.domains)
        && Object.values(myEntity.domains).find(x=> x.is_primary)
        && Object.values(myEntity.domains).find(x => x.is_primary).verification
        && Object.values(myEntity.domains).find(x => x.is_primary).verification.verification_id;
    //TODO: messing with zindex like below is not a best practice... like, at all
    return(
        // <span>
            <Popper anchorEl={anchorEl}
                    open={open}
                    placement={"bottom-end"}
                    style={{zIndex: "1000000"}}>
                <Paper  style={{ width: "600px" }}
                        elevation={6}
                        variant={"outlined"}>

                    <div className={"row m-2 p-2 text-center"} >
                        <div className={"col"}>
                            <h2>Please Confirm Ownership of Your Company Domain</h2>
                        </div>
                    </div>

                    <div className={"row mx-2 px-2"} style={{width: "100%"}}>
                        <div className={"col"}>
                            <p>
                                To protect the security of our customers, we require proof of authority to conduct security testing before providing sensitive information or enabling testing. Please add a DNS TXT record for your primary domain using the value below.
                            </p>
                        </div>
                    </div>


                    <div className={"row mx-2 px-2"} style={{width: "100%"}}>
                        <div className={"col"}>
                        <BBCodeCopyContainer
                            titleDescriber={"Required DNS TXT Record"}
                            language={"plaintext"}
                            displayText={verification_id ? verification_id : `Problem finding verification code. Please contact support@breachbits.com.`}
                            titleIcon={<BBIconCodeDocument/>}
                            isNotExecutable={true}
                            showDownload
                        />
                        </div>
                    </div>

                    <div className={"row m-2 p-2"} style={{width: "100%"}}>
                        <div className={"col"}>
                            <BBExternalLink href={`https://support.breachbits.com/knowledge/why-and-how-to-verify-your-company-with-a-dns-record`}>Learn more about how to do this and why we require it.</BBExternalLink>
                        </div>
                    </div>

                </Paper>
            </Popper>

// <!--        </span>-->
)
}

export default OwnershipRequiredPopper